import React from 'react';
import { useDevice } from '@/hooks';
import TableBookingDesktop from '@/features/booking/components/desktop/TableBookingDesktop';
import TableBookingMobile from '@/features/booking/components/mobile/TableBookingMobile';

const TableBookingTicketPage: React.FC = () => {
  const device = useDevice();

  if (device === 'mobile') {
    return <TableBookingMobile />;
  }

  return <TableBookingDesktop />;
};

export default TableBookingTicketPage;
